import { render } from "./OrdersView.vue?vue&type=template&id=45e6a38c&scoped=true&ts=true"
import script from "./OrdersView.vue?vue&type=script&lang=ts"
export * from "./OrdersView.vue?vue&type=script&lang=ts"

import "./OrdersView.vue?vue&type=style&index=0&id=45e6a38c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e6a38c"]])

export default __exports__